<template>
    <div :class="['app-upload']">
        <template v-if="multiple">
            <el-upload :accept="accept"
                       :data="data"
                       :multiple="true"
                       :action="uploadServer"
                       :headers="cUploadHeaders"
                       :show-file-list="false"
                       :before-upload="beforeUploadFile"
                       :on-error="uploadFileError"
                       :on-success="uploadFileSuccess">
                <el-button :loading="uploadingFile" icon="el-icon-upload"></el-button>
            </el-upload>
            <div v-if="preview" class="preview-list" style="padding: 12px 0;margin: 0 -6px;">
                <div v-for="(item, index) in privateValue" :key="index"
                     style="display: inline-block;margin: 0 6px; position: relative">
                    <el-image :src="item"
                              style="width: 100px; height: 100px;border-radius: 3px;">
                    </el-image>
                    <el-button @click="deleteItem(index)" type="danger" icon="el-icon-delete" circle
                               style="position: absolute;z-index: 2;top: -6px;right:-6px;" size="mini"></el-button>
                </div>
            </div>
        </template>
        <template v-else>
            <el-input v-model="privateValue" :disabled="inputState">
                <div slot="append">
                    <el-upload :accept="accept"
                               :data="data"
                               :multiple="false"
                               :action="uploadServer"
                               :headers="cUploadHeaders"
                               :show-file-list="false"
                               :before-upload="beforeUploadFile"
                               :on-error="uploadFileError"
                               :on-success="uploadFileSuccess">
                        <el-button :loading="uploadingFile" icon="el-icon-upload"></el-button>
                    </el-upload>
                </div>
            </el-input>
            <div v-if="preview" class="image-preview"
                 :style="'background-image: url(' + this.privateValue + ');'"></div>
        </template>
    </div>
</template>
<style scoped>
    .image-preview {
        width: 100px;
        height: 100px;
        box-shadow: 0 0 1px rgba(0, 0, 0, .35);
        margin-top: 10px;
        border-radius: 3px;
        background: #aaa;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
</style>
<script>
import baseUrl from '@/base-url'

export default {
    name: 'AppUpload',
    props: {
        value: {
            default: null
        },
        accept: {
            default: null
        },
        uploadServer: {
            default: baseUrl + '/admin/upload/file'
        },
        uploadHeaders: {
            default: null
        },
        preview: {
            default: false
        },
        data: {
            type: Object,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        inputState: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploadingFile: false,
            privateValue: this.value
        }
    },
    created() {
    },
    watch: {
        value(newValue, oldValue) {
            this.privateValue = newValue
        },
        privateValue(newVal, oldVal) {
            this.$emit('input', newVal)
        }
    },
    computed: {
        cValue() {
            return this.value
        },
        cUploadHeaders() {
            if (!this.uploadHeaders) {
                return {
                    'Access-Token': this.$store.state.user.access_token
                }
            }
            return this.uploadHeaders
        }
    },
    methods: {
        deleteItem(index) {
            this.privateValue.splice(index, 1)
        },
        beforeUploadFile(e) {
            this.uploadingFile = true
        },
        uploadFileError(err, file, fileList) {
            this.uploadingFile = false
            this.$message.error('文件上传失败。')
            console.log(err)
        },
        uploadFileSuccess(response, file, fileList) {
            this.uploadingFile = false
            if (response.code === 0) {
                if (this.multiple) {
                    if (this.privateValue && this.privateValue.length) {
                        this.privateValue.push(response.data.url)
                    } else {
                        this.privateValue = [response.data.url]
                    }
                } else {
                    this.privateValue = response.data.url
                }
                this.$emit('on-success', response)
            } else {
                this.$message.error(response.msg)
            }
        }
    }
}
</script>
